export default __webpack_public_path__ + "static/media/platformity-logo.6ed9df9e.png";